import { render, staticRenderFns } from "./GarbageRemovalPricingForm.vue?vue&type=template&id=a13a67e2&"
import script from "./GarbageRemovalPricingForm.vue?vue&type=script&lang=js&"
export * from "./GarbageRemovalPricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports